import {useSelector} from 'react-redux';

import {useLockUnlockSettingContent} from '@/containers/DevicesPage/hooks/useSettingsContent';
import {useLockEnabled} from '@/hooks/useDeviceSettingsEnabled';
import {selectIsSelectedDeviceConnected} from '@/state/selectors/device';

export const useDeviceLockVisibility = () => {
    const isSelectedDeviceConnected = useSelector(selectIsSelectedDeviceConnected);
    const isDeviceLockEnabled = useLockEnabled();
    const deviceLockContent = useLockUnlockSettingContent();

    const isVisible = isSelectedDeviceConnected && isDeviceLockEnabled && deviceLockContent;

    return isVisible;
};
